import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

//Components
import TopBar from "./components/navigations/TopBar";
import MainFooter from "./components/footer/MainFooter";
import Home from "./pages/Home";
import Teachers from "./pages/Teachers";
import AboutUs from "./pages/AboutUs";
import OurMissions from "./pages/OurMissions";
import Affiliation from "./pages/Affiliation";
import Student from "./pages/Student";
import ImportantDocs from "./pages/ImportantDocs";
import Affidavit from "./pages/Affidavit";
import BuildingSafety from "./pages/BuildingSafety";
import FireSafety from "./pages/FireSafety";
import Noc from "./pages/Noc";
import Recognition from "./pages/Recognition";
import Sanitation from "./pages/Sanitation";
import SmcMember from "./pages/SmcMember";
import NoticeDetail from "./pages/NoticeDetail";
import CalenderAndHolidays from "./pages/CalenderAndHolidays";
import ParentTeacher from "./pages/ParentTeacher";
import FeesStructure from "./pages/FeesStructure";
import RegisterCertificate from "./pages/RegisterCertificate";
import Disclosure from "./pages/Disclosure";
import ScrollToTop from "./components/ScrollToTop ";

function App() {
  return (
    <Router>
      <div className="bg-gray-200">
        <TopBar />
        <ScrollToTop />
        <Switch>
          <Route path="/calender_holidays" component={CalenderAndHolidays} />
          <Route path="/register_certificate" component={RegisterCertificate} />
          <Route path="/disclosure" component={Disclosure} />
          <Route path="/fees_structure" component={FeesStructure} />
          <Route path="/notice/:id" component={NoticeDetail} />
          <Route path="/docs" component={ImportantDocs} />
          <Route path="/affidavit" component={Affidavit} />
          <Route path="/building_safety" component={BuildingSafety} />
          <Route path="/fire_safety" component={FireSafety} />
          <Route path="/noc" component={Noc} />
          <Route path="/recognition" component={Recognition} />
          <Route path="/sanitation" component={Sanitation} />
          <Route path="/smc_member" component={SmcMember} />
          <Route path="/pta" component={ParentTeacher} />
          <Route path="/affiliate" component={Affiliation} />
          <Route path="/student" component={Student} />
          <Route path="/teachers" component={Teachers} />
          <Route path="/about" component={AboutUs} />
          <Route path="/missions" component={OurMissions} />
          <Route path="/" component={Home} />
        </Switch>
        <MainFooter />
      </div>
    </Router>
  );
}

export default App;
